import { render, staticRenderFns } from "./OnboardingSteps.vue?vue&type=template&id=58abbf96&scoped=true"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSteps.vue?vue&type=style&index=0&id=58abbf96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58abbf96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58abbf96')) {
      api.createRecord('58abbf96', component.options)
    } else {
      api.reload('58abbf96', component.options)
    }
    module.hot.accept("./OnboardingSteps.vue?vue&type=template&id=58abbf96&scoped=true", function () {
      api.rerender('58abbf96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/OnboardingSteps.vue"
export default component.exports